<template>
  <div class="reglement-facture">
    <v-tooltip bottom color="#311B92">
      <template v-slot:activator="{ on, attrs }">
        <div
          class="block-icon mr-2"
          v-on="on"
          v-bind="attrs"
          @click="handleModalAddReglement"
          v-if="checkPermission('RFTHNR')"
        >
          <font-awesome-icon icon="file-invoice-dollar" class="file-medical" />
        </div>
      </template>
      <span>Ajouter paiement </span>
    </v-tooltip>
    <!-- AJOUTER NOUVELLE PAIEMENT -->
    <v-dialog
      v-model="dialog"
      max-width="1500px"
      scrollable
      hide-overlay
      persistent
    >
      <v-card>
        <v-card-title class="text-h6 title-modal">
          <v-label class="label-header">Nouveau paiement</v-label>
          <v-btn
            class="btn-close-header"
            icon
            @click.prevent="hideModal"
            title="Fermer"
            color="#704ad1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="line-hr-header"></v-divider>

        <v-card-text class="body-card center-text  mt-2">
          <div v-if="show == true" class="loading-custom-reglement-block">
            <Half-circle-spinner
              :animation-duration="1000"
              :size="50"
              :color="'#704ad1'"
              class="loeder"
            />
          </div>
          <v-form ref="form" lazy-validation>
            <v-row class="mt-2">
              <v-col col xs="2" sm="2" md="2">
                <v-select
                  placeholder=""
                  :items="computedTypePartenaire"
                  label="Type Partenaire"
                  v-model="reglementToAdd.type_partenaire"
                  outlined
                  :persistent-placeholder="true"
                  dense
                  @change="getClientsTypePartenaire"
                  required
                  :rules="[v => !!v || 'Type Partenaire obligatoire']"
                  class="msg-error"
                  validate-on-blur
                  :menu-props="{ bottom: true, offsetY: true }"
                  color="#704ad1"
                  item-color="#704ad1"
                >
                </v-select>
              </v-col>
              <v-col col xs="2.5" sm="2.5" md="2.5">
                <v-select
                  placeholder=""
                  :items="computedClients"
                  label="Partenaire"
                  v-model="reglementToAdd.filiale_id"
                  outlined
                  :disabled="selectClient"
                  :persistent-placeholder="true"
                  dense
                  required
                  @change="
                    reglementToAdd.filiale_id = $event;
                    getFacturesFiliales();
                  "
                  :menu-props="{ bottom: true, offsetY: true }"
                  :loading="getLoaderClientReglementList"
                  no-data-text="Aucun partenaire trouvée"
                  :rules="[v => !!v || 'Partenaire obligatoire']"
                  class="msg-error"
                  validate-on-blur
                  color="#704ad1"
                  item-color="#704ad1"
                >
                </v-select>
              </v-col>

              <v-col col xs="2" sm="2" md="2">
                <v-select
                  placeholder=""
                  :items="computedTypeReglement"
                  label="Type paiement"
                  v-model="reglementToAdd.type_reglement"
                  outlined
                  :rules="[v => !!v || 'Type paiement obligatoire']"
                  required
                  class="msg-error"
                  validate-on-blur
                  :persistent-placeholder="true"
                  dense
                  :menu-props="{ bottom: true, offsetY: true }"
                  color="#704ad1"
                  item-color="#704ad1"
                >
                </v-select>
              </v-col>
              <lcr
                :montantFix="true"
                :reglement="reglementToAdd"
                :factures="facturesReglement"
                @saveDataForLcr="saveDataForLcr"
                :resetModalLcr="resetModalLcr"
              />
              <v-col
                col
                xs="2.5"
                sm="2.5"
                md="2.5"
                v-if="!computedPaiementNameSelected.includes('LCR')"
              >
                <v-select
                  placeholder=""
                  required
                  :items="computedConditionPaiement"
                  label="Conditions du paiement"
                  v-model="reglementToAdd.condition_paiement"
                  outlined
                  :persistent-placeholder="true"
                  dense
                  :rules="[v => !!v || 'Conditions du paiement obligatoire']"
                  class="msg-error"
                  validate-on-blur
                  :menu-props="{ bottom: true, offsetY: true }"
                  color="#704ad1"
                  item-color="#704ad1"
                >
                </v-select>
              </v-col>
              <v-col
                col
                xs="2"
                sm="2"
                md="2"
                v-if="getConditionAmountNonLettre"
              >
                <v-text-field
                  label="Montant non alloué"
                  placeholder=""
                  :persistent-placeholder="true"
                  outlined
                  dense
                  :disabled="true"
                  :value="getAmountNonLettrerReglemnt | numberWithSpaces"
                  color="#704ad1"
                ></v-text-field>
              </v-col>
              <v-col
                col
                :xs="getConditionAmountNonLettre ? '2' : '4'"
                :sm="getConditionAmountNonLettre ? '2' : '4'"
                :md="getConditionAmountNonLettre ? '2' : '4'"
              >
                <v-text-field
                  @input="calculRestePayer"
                  label="Montant à payer"
                  type="number"
                  placeholder=""
                  :persistent-placeholder="true"
                  outlined
                  dense
                  v-model="reglementToAdd.montant_a_payer"
                  min="0"
                  step="0.01"
                  :rules="[v => !!v || 'Montant à payer obligatoire']"
                  class="msg-error"
                  validate-on-blur
                  required
                  color="#704ad1"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col col xs="1.25" sm="1.25" md="1.25">
                <v-select
                  placeholder=""
                  :items="computedUnite"
                  label="Unité"
                  v-model="reglementToAdd.unite"
                  outlined
                  :persistent-placeholder="true"
                  dense
                  :menu-props="{ bottom: true, offsetY: true }"
                  color="#704ad1"
                  item-color="#704ad1"
                >
                </v-select>
              </v-col>
              <v-col col xs="2.5" sm="2.5" md="2.5">
                <v-text-field
                  label="Réference"
                  type="text"
                  placeholder=""
                  :persistent-placeholder="true"
                  outlined
                  dense
                  v-model="reglementToAdd.ref"
                  color="#704ad1"
                ></v-text-field>
              </v-col>
              <v-col col xs="2" sm="2" md="2">
                <div class="label-for-no-vuetify ">
                  <div class="custom-label">Date paiement</div>
                  <date-picker
                    id="date_paiement"
                    value-type="format"
                    format="DD-MM-YYYY"
                    v-model="reglementToAdd.date_paiement"
                    required
                    type="date"
                  ></date-picker>
                </div>
              </v-col>
              <v-col col xs="2" sm="2" md="2">
                <v-text-field
                  label="Reste"
                  placeholder=""
                  :persistent-placeholder="true"
                  outlined
                  dense
                  :disabled="true"
                  :value="reglementToAdd.reste | numberWithSpaces"
                  color="#704ad1"
                ></v-text-field>
              </v-col>
              <v-col col xs="2" sm="2" md="2">
                <v-text-field
                  label="Solde courant"
                  placeholder=""
                  :persistent-placeholder="true"
                  outlined
                  dense
                  :disabled="true"
                  :value="reglementToAdd.solde_init | numberWithSpaces"
                  color="#704ad1"
                ></v-text-field>
              </v-col>
              <v-col col xs="2" sm="2" md="2">
                <v-text-field
                  label="Montant Echu"
                  placeholder=""
                  :persistent-placeholder="true"
                  outlined
                  dense
                  :disabled="true"
                  :value="reglementToAdd.solde_echeance | numberWithSpaces"
                  color="#704ad1"
                ></v-text-field>
              </v-col>
            </v-row>
            <badge
              v-if="getConditionAmountNonLettre"
              class="mt-3 mb-3"
              color="purple"
            />
            <v-row>
              <v-col col xs="12" sm="12" md="12">
                <v-textarea
                  outlined
                  label="Note"
                  v-model="reglementToAdd.note"
                  :persistent-placeholder="true"
                  clearable
                  rows="3"
                  color="#704ad1"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-tabs
              background-color="#f1edfb"
              color="#704ad1"
              class="tabs-add-reglement-fac mt-2"
              v-model="indexTab"
            >
              <v-tab active class="tab-add-reglement-fac">
                <span class="tab-text-bold">
                  {{ 'Factures à régler ' + vendeur }}
                </span>
              </v-tab>
              <v-tab-item>
                <div class="btn-end-postion mt-2">
                  <v-text-field
                    label="Rechercher"
                    placeholder="Rechercher"
                    :persistent-placeholder="true"
                    outlined
                    v-model="search"
                    color="#704ad1"
                  ></v-text-field>
                </div>
                <div class="table-reglement-fac-dialog">
                  <v-data-table
                    v-model="selectedTable"
                    :headers="fields"
                    :items="facturesReglementComputed"
                    class="table-facture"
                    hide-default-footer
                    :calculate-widths="false"
                    :fixed-header="true"
                    hide-action
                    disable-sort
                    no-data-text="Il n'y a aucun enregistrement à afficher"
                  >
                    <!-- HEADERS TABLE -->
                    <template v-slot:[`header.check_all`]="{ header }">
                      <th>
                        <span v-if="header.value != 'check_all'">
                          {{ header.label }}</span
                        >
                        <div v-else>
                          <div
                            class="checkbox-class-show mx-auto"
                            :class="{
                              'checkbox-class-show-checked': checkAll
                            }"
                            @click="
                              checkAll = !checkAll;
                              handleCheckAll();
                            "
                          >
                            <font-awesome-icon
                              icon="check"
                              v-if="checkAll"
                              class="check"
                            />
                          </div>
                        </div>
                      </th>
                    </template>
                    <!-- BODY TABLE -->
                    <template v-slot:[`item.check_all`]="{ item }">
                      <td class="custom-cell sticky-header-1">
                        <div
                          class="checkbox-class-show mx-auto"
                          :class="{ 'checkbox-class-show-checked': item.check }"
                          @click="
                            item.check = !item.check;
                            checkFacture(item);
                          "
                        >
                          <font-awesome-icon
                            icon="check"
                            v-if="item.check"
                            class="check"
                          />
                        </div>
                      </td>
                    </template>
                    <template v-slot:[`item.num`]="{ item }">
                      <td class="custom-cell">{{ item.num }}</td>
                    </template>
                    <template v-slot:[`item.total_ttc`]="{ item }">
                      <td class="custom-cell">
                        {{ item.total_ttc | numberWithSpaces }}
                      </td>
                    </template>
                    <template v-slot:[`item.montant_regle`]="{ item }">
                      <td class="custom-cell">
                        {{ item.montant_regle | numberWithSpaces }}
                      </td>
                    </template>
                    <template v-slot:[`item.montant_a_regle`]="{ item }">
                      <EditableInput
                        :editable="
                          reglementToAdd.montant_a_payer != null &&
                            item.check == true
                        "
                        champName="montant_a_regle"
                        :item="item"
                        :value="item.montant_a_regle"
                        type="text"
                        editableType="input"
                        :updateFunction="updateMontantRegler"
                        :defaultColor="true"
                        :float="true"
                      />
                    </template>
                    <template v-slot:[`item.reste`]="{ item }">
                      <td class="custom-cell">
                        {{ item.reste | numberWithSpaces }}
                      </td>
                    </template>
                    <template v-slot:[`item.vendeur`]="{ item }">
                      <td class="custom-cell">
                        {{ item.vendeur ? item.vendeur : '-' }}
                      </td>
                    </template>
                    <template v-slot:[`item.client`]="{ item }">
                      <td class="custom-cell">
                        {{ item.client ? item.client : '-' }}
                      </td>
                    </template>
                    <template v-slot:[`item.delais_paiement`]="{ item }">
                      <td class="custom-cell">
                        {{
                          formateDateGetters(item.date_echeance)
                            ? formateDateGetters(item.date_echeance)
                            : '-'
                        }}
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-tab-item>
              <v-tab class="tab-add-reglement-fac"
                ><span class="tab-text-bold">Fichiers jointes</span>
              </v-tab>
              <v-tab-item>
                <PieceJointe
                  :permission="true"
                  :noItems="true"
                  :item="[]"
                  :show="true"
                  typeVoir="addFiles"
                  @showFiles="showFiles"
                  :resetModalData="resetModalLcr"
                ></PieceJointe>
              </v-tab-item>
            </v-tabs>
          </v-form>
        </v-card-text>

        <v-divider class="line-hr-footer"></v-divider>
        <v-card-actions class="actions-msg-btn-modal">
          <div v-if="error" class="message-error-modal">
            <ul v-if="Array.isArray(error)" class="mb-0">
              <li v-for="(e, index) in error" :key="index">
                {{ e }}
              </li>
            </ul>
            <div v-else>{{ error }}</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="#704ad1"
            text
            @click="handleSubmitAddReglement"
            :class="{ loader: loading }"
            :loading="loading"
          >
            Valider
          </v-btn>
          <v-btn text @click="hideModal" :class="{ loader: loading }"
            >Annuler</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';

import { mapActions, mapGetters } from 'vuex';
// import SelectSimpleWithSearch from '../../component/selectSimpleWithSearch.vue';
export default {
  data() {
    return {
      selectedTable: [],
      dialog: false,
      search: null,
      resetModalLcr: false,
      error: [],
      selectClient: false,
      dataLcr: null,
      checkAll: false,
      reglementToAdd: {
        filiale_id: null,
        type_partenaire: 'Client',
        type_reglement: null,
        condition_paiement: null,
        montant_a_payer: null,
        unite: 'EUR',
        ref: null,
        date_paiement: moment(Date.now()).format('DD-MM-YYYY'),
        reste: null,
        solde: null,
        solde_init: null,
        solde_echeance: null,
        note: null,
        files: []
      },
      factures: [],
      show: false,
      loading: false,
      vendeur: '',
      indexTab: 'tab-0',
      fields: [
        {
          value: 'check_all',
          text: '',
          width: '40px !important',
          class: 'sticky-header-1'
        },
        {
          value: 'num',
          text: 'Numéro'
        },
        {
          value: 'total_ttc',
          text: 'Montant Total'
        },
        {
          value: 'reste',
          text: 'Reste'
        },
        {
          value: 'montant_regle',
          text: 'Montant Réglé'
        },
        {
          value: 'montant_a_regle',
          text: 'Montant à Régler'
        },
        {
          value: 'vendeur',
          text: 'Société'
        },
        {
          value: 'client',
          text: 'Client'
        },
        {
          value: 'delais_paiement',
          text: 'Délais du paiement'
        }
      ]
    };
  },
  filters: {
    formateDate: value => {
      if (value == '' || value == null) {
        return '-';
      } else if (moment(value, 'DD-MM-YYYY', true).isValid()) {
        return value;
      } else {
        return moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY');
      }
    },
    formateValue: value => {
      if (value && value != null && value != '') {
        return parseFloat(value)?.toFixed(2);
      }
      return value;
    },
    numberWithSpaces: x => {
      // return new Intl.NumberFormat().format(x);
      if (x != null && x != undefined) {
        if (Math.sign(x) === -1) {
          var y = Math.abs(x);
          var parts = y.toString().split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          return '-' + parts.join('.');
        } else {
          var parts = x.toString().split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          return parts.join('.');
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'clientsReglement',
      'TypeReglement',
      'ConditionPaiement',
      'facturesReglement',
      'soldeClient',
      'soldeEcheance',
      'checkPermission',
      'getLoaderClientReglementList',
      'getAmountNonLettrerReglemnt',
      'getConditionAmountNonLettre',
      'formateDateGetters'
    ]),
    computedPaiementNameSelected() {
      if (this.reglementToAdd && this.reglementToAdd.type_reglement != null) {
        let fund = this.TypeReglement.filter(
          i => i.id == this.reglementToAdd.type_reglement
        );
        return fund && fund.length ? fund[0].name : null;
      }
      return this.reglementToAdd.type_reglement + '';
    },
    facturesReglementComputed() {
      if (this.search != null && this.search != '') {
        return this.facturesReglement.filter(item =>
          item.num.toLowerCase().includes(this.search.toLowerCase())
        );
      }
      return this.facturesReglement;
    },
    computedCheckAll() {
      let table = [];
      if (
        this.facturesReglement.map(item => {
          if (item.check == true) {
            table.push(item);
          }
        })
      )
        if (table.length == this.facturesReglement.length) {
          return true;
        }
      return false;
    },
    computedTypePartenaire() {
      let typePartenaire = [
        { text: 'Client', value: 'Client' },
        { text: 'Fournisseur', value: 'Fournisseur' }
      ];
      return typePartenaire;
    },
    computedUnite() {
      let unite = [
        { text: 'EUR', value: 'EUR' },
        { text: 'USD', value: 'USD' }
      ];
      return unite;
    },
    computedClients() {
      return this.clientsReglement.map(item => {
        return {
          text: item.name,
          value: item.id
        };
      });
    },
    computedTypeReglement() {
      return this.TypeReglement.map(item => {
        return {
          text: item.name,
          value: item.id
        };
      });
    },

    computedConditionPaiement() {
      return this.ConditionPaiement.map(item => {
        return {
          text: item.name,
          value: item.id
        };
      });
    }
  },
  methods: {
    ...mapActions([
      'getClientsReglement',
      'getAllTypesReglement',
      'getAllConditionsPaiement',
      'getFactureByFilialeReglement',
      'getSoldeClient',
      'createReglement',
      'resetMutationsReglements',
      'getSoldeEcheance',
      'createReglementLcrFactureEcheances',
      'resetListPartenaire',
      'getAmountNonLettrer'
    ]),
    showFiles(file) {
      this.reglementToAdd.files = file;
    },
    saveDataForLcr(data) {
      this.dataLcr = data;
    },
    handleModalAddReglement() {
      this.resetMutationsReglements();
      this.dialog = true;
      this.getClientsReglement({
        type_partenaire: this.reglementToAdd.type_partenaire
      });
    },
    async getClientsTypePartenaire() {
      this.resetMutationsReglements();
      this.reglementToAdd.solde = null;
      this.reglementToAdd.solde_echeance = null;
      this.selectClient = true;
      const response = await this.getClientsReglement({
        type_partenaire: this.reglementToAdd.type_partenaire
      });
      if (response) {
        this.selectClient = false;
        this.reglementToAdd.filiale_id = null;
      }
    },
    updateMontantRegler(payload) {
      this.reglementToAdd.reste = parseFloat(this.reglementToAdd.reste);
      this.reglementToAdd.solde = parseFloat(this.reglementToAdd.solde);
      if (parseFloat(payload.value) == 0) {
        payload.row.check = false;
      }
      if (
        parseFloat(this.reglementToAdd.reste) +
          parseFloat(payload.row.montant_a_regle) >
        parseFloat(payload.value)
      ) {
        let ancien_montant_a_regle = 0;
        ancien_montant_a_regle = payload.row.montant_a_regle;
        payload.row.montant_a_regle = parseFloat(payload.value).toFixed(2);
        payload.row.reste = parseFloat(
          payload.row.resteInitial - parseFloat(payload.value).toFixed(2)
        );
        payload.row.reste = payload.row.reste.toFixed(2);
        payload.row.reste = parseFloat(payload.row.reste);
        this.reglementToAdd.reste =
          this.reglementToAdd.reste + parseFloat(ancien_montant_a_regle);
        this.reglementToAdd.reste =
          this.reglementToAdd.reste - parseFloat(payload.value);
        this.reglementToAdd.reste = this.reglementToAdd.reste.toFixed(2);
        this.reglementToAdd.solde =
          this.reglementToAdd.solde + parseFloat(ancien_montant_a_regle);
        this.reglementToAdd.solde =
          this.reglementToAdd.solde - parseFloat(payload.value);
        this.reglementToAdd.solde = this.reglementToAdd.solde.toFixed(2);
      }
    },
    deleteUploadFile(index) {
      this.reglementToAdd.files.splice(index, 1);
    },
    rowClass(item, type) {
      if (item && item.reste == 0) {
        return 'ligneAlert';
      }
      return 'ligneNormale';
    },
    handleCheckAll() {
      if (this.checkAll == true) {
        let table = this.facturesReglementComputed.filter(
          item => item.check == false
        );
        table.map(item => {
          if (this.reglementToAdd.reste > 0) {
            item.check = true;
            this.checkFacture(item);
          }
        });
      } else {
        let table = this.facturesReglementComputed.filter(
          item => item.check == true
        );
        table.map(item => {
          item.check = false;
          this.checkFacture(item);
        });
      }
    },
    checkFacture(item) {
      let dataCheck = this.facturesReglement.filter(
        i => i.check == true && i.id != item.id
      );
      if (
        dataCheck.length == 0 ||
        (dataCheck.length > 0 && dataCheck[0].vendeur_id == item.vendeur_id)
      ) {
        this.reglementToAdd.reste = parseFloat(this.reglementToAdd.reste);
        this.reglementToAdd.solde = parseFloat(this.reglementToAdd.solde);

        if (this.reglementToAdd.reste > 0) {
          if (item.check == true) {
            if (this.reglementToAdd.reste > parseFloat(item.resteInitial)) {
              this.reglementToAdd.reste =
                this.reglementToAdd.reste - parseFloat(item.resteInitial);
              this.reglementToAdd.reste = this.reglementToAdd.reste.toFixed(2);
              item.reste = 0;
              item.montant_a_regle =
                parseFloat(item.montant_a_regle) +
                parseFloat(item.resteInitial);
              this.reglementToAdd.solde =
                this.reglementToAdd.solde - parseFloat(item.montant_a_regle);
              this.reglementToAdd.solde = this.reglementToAdd.solde.toFixed(2);
              this.reglementToAdd.solde = Math.abs(this.reglementToAdd.solde);
              if (this.computedCheckAll == true) {
                this.checkAll = true;
              } else {
                this.checkAll = false;
              }
            } else {
              item.montant_a_regle = this.reglementToAdd.reste.toFixed(2);
              item.reste =
                parseFloat(item.resteInitial) - this.reglementToAdd.reste;
              item.reste = item.reste.toFixed(2);
              this.reglementToAdd.reste = 0;
              this.reglementToAdd.solde =
                parseFloat(this.reglementToAdd.solde) -
                parseFloat(item.montant_a_regle);
              this.reglementToAdd.solde = this.reglementToAdd.solde.toFixed(2);
              this.reglementToAdd.solde = Math.abs(this.reglementToAdd.solde);
              if (this.computedCheckAll == true) {
                this.checkAll = true;
              } else {
                this.checkAll = false;
              }
            }
          } else {
            this.reglementToAdd.reste =
              this.reglementToAdd.reste + parseFloat(item.montant_a_regle);
            this.reglementToAdd.reste = this.reglementToAdd.reste.toFixed(2);
            this.reglementToAdd.solde =
              this.reglementToAdd.solde + parseFloat(item.montant_a_regle);
            this.reglementToAdd.solde = this.reglementToAdd.solde.toFixed(2);
            item.reste = parseFloat(item.resteInitial);
            item.montant_a_regle = parseFloat(item.montant_a_regle_initial);
            if (this.computedCheckAll == true) {
              this.checkAll = true;
            } else {
              this.checkAll = false;
            }
          }
        } else {
          if (item.check == false) {
            this.reglementToAdd.reste =
              parseFloat(this.reglementToAdd.reste) +
              parseFloat(item.montant_a_regle);

            this.reglementToAdd.reste = this.reglementToAdd.reste.toFixed(2);
            this.reglementToAdd.solde = parseFloat(
              this.reglementToAdd.solde
            ).toFixed(2);
            this.reglementToAdd.solde =
              parseFloat(this.reglementToAdd.solde) +
              parseFloat(item.montant_a_regle);
            this.reglementToAdd.solde = this.reglementToAdd.solde.toFixed(2);

            item.reste = parseFloat(item.resteInitial);
            item.montant_a_regle = parseFloat(item.montant_a_regle_initial);
            this.checkAll = false;
          } else {
            this.$set(item, 'check', false);

            // item.check = false;
            this.checkAll = false;
          }
        }
      } else {
        item.check = !item.check;
      }
    },
    resetModal() {
      this.reglementToAdd = {
        filiale_id: null,
        type_partenaire: 'Client',
        type_reglement: null,
        condition_paiement: null,
        montant_a_payer: null,
        unite: 'EUR',
        ref: null,
        date_paiement: moment(Date.now()).format('DD-MM-YYYY'),
        reste: null,
        solde: null,
        solde_echeance: null,
        note: null,
        files: []
      };
      this.show = false;
      this.loading = false;
      this.vendeur = '';
      this.error = [];
      this.indexTab = 'tab-0';
      this.resetListPartenaire([]);
    },
    hideModal() {
      this.dialog = false;
      this.resetModal();
      this.resetMutationsReglements();
      this.$refs.form.resetValidation();
      this.resetModalLcr = !this.resetModalLcr;
    },
    calculRestePayer() {
      this.reglementToAdd.reste = this.reglementToAdd.montant_a_payer;
      let TableF = this.facturesReglement?.filter(item => item.check == false);
      if (TableF.length != this.facturesReglement.length) {
        this.getFacturesFiliales();
      }
    },
    async getFacturesFiliales() {
      this.show = true;
      const response = await this.getFactureByFilialeReglement({
        filiale_id: this.reglementToAdd.filiale_id,
        type_partenaire: this.reglementToAdd.type_partenaire
      });
      if (response) {
        this.clientsReglement.map(item => {
          if (item.id == this.reglementToAdd.filiale_id) {
            this.vendeur = item.name;
            this.reglementToAdd.type_reglement = item.payment_type_id;
            this.reglementToAdd.condition_paiement = item.payment_condition_id;
          }
        });
        const responseSld = await this.getSoldeClient({
          id: this.reglementToAdd.filiale_id,
          type_partenaire: this.reglementToAdd.type_partenaire
        });
        if (responseSld) {
          this.reglementToAdd.solde = this.soldeClient;
          this.reglementToAdd.solde_init = this.soldeClient;
          this.getAmountNonLettrer({
            filiale_id: this.reglementToAdd.filiale_id,
            type_partenaire: this.reglementToAdd.type_partenaire
          });
          const responseSldEch = await this.getSoldeEcheance({
            id: this.reglementToAdd.filiale_id,
            type_partenaire: this.reglementToAdd.type_partenaire
          });
          if (responseSldEch) {
            this.reglementToAdd.solde_echeance = this.soldeEcheance;
            this.show = false;
          }
        }
      }
    },
    async handleSubmitAddReglement() {
      if (this.$refs.form.validate()) {
        if (this.reglementToAdd.montant_a_payer == 0) {
          this.error = 'If faut avoir le montant à payer supèrieur à 0';
        } else {
          this.loading = true;
          this.error = [];
          let bodyFormData = new FormData();
          bodyFormData.append('balance', this.reglementToAdd.reste);
          bodyFormData.append('amount', this.reglementToAdd.montant_a_payer);
          bodyFormData.append('currency', this.reglementToAdd.unite);
          bodyFormData.append(
            'payment_date',
            this.reglementToAdd.date_paiement
          );
          bodyFormData.append('type_id', this.reglementToAdd.type_reglement);
          if (!this.computedPaiementNameSelected.includes('LCR')) {
            bodyFormData.append(
              'payment_condition_id',
              this.reglementToAdd.condition_paiement
            );
          }
          bodyFormData.append('filiale_id', this.reglementToAdd.filiale_id);
          bodyFormData.append('payment_note', this.reglementToAdd.note);
          bodyFormData.append('reference', this.reglementToAdd.ref);
          bodyFormData.append(
            'type_partenaire',
            this.reglementToAdd.type_partenaire
          );

          for (let i = 0; i < this.facturesReglement.length; i++) {
            if (this.facturesReglement[i].check == true) {
              bodyFormData.append(
                'factures[' + i + '][id]',
                this.facturesReglement[i].id
              );
              bodyFormData.append(
                'factures[' + i + '][montant_regle]',
                this.facturesReglement[i].montant_a_regle
              );
              bodyFormData.append(
                'factures[' + i + '][total_ttc]',
                this.facturesReglement[i].total_ttc
              );
            }
          }
          for (let i = 0; i < this.reglementToAdd.files?.length; i++) {
            bodyFormData.append(
              'files[' + i + '][file]',
              this.reglementToAdd.files[i]
            );
            bodyFormData.append(
              'files_descriptions[' + i + ']',
              this.reglementToAdd.files[i]['description']
            );
          }
          const response = await this.createReglement(bodyFormData);
          if (response.success) {
            if (
              this.reglementToAdd.type_reglement != null &&
              this.dataLcr &&
              this.dataLcr.lcr &&
              this.dataLcr.lcr.length != 0 &&
              this.computedPaiementNameSelected.includes('LCR')
            ) {
              let bodyFormDataEch = new FormData();
              this.dataLcr?.lcr?.forEach((element, i) => {
                bodyFormDataEch.append(
                  'echeances[' + i + '][libelle]',
                  element.libelle
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][client_id]',
                  this.dataLcr.client_id
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][date_echeance]',
                  element.date
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][beneficiaire_id]',
                  this.dataLcr.beneficiaire_id
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][valeur_en]',
                  this.dataLcr.valeur_en
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][date_envoi]',
                  null
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][date_signature]',
                  null
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][date_valeur]',
                  null
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][devise]',
                  this.dataLcr.devise
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][amount]',
                  element.value
                );
                bodyFormDataEch.append(
                  'echeances[' + i + '][rib_id]',
                  this.dataLcr.rib.id
                );
              });
              const resEch = await this.createReglementLcrFactureEcheances({
                response: response.response,
                data: bodyFormDataEch
              });
              if (resEch) {
                // this.resetModalLcr = !this.resetModalLcr;
                this.hideModal();
                this.loading = false;
              }
            } else {
              // this.resetModalLcr = !this.resetModalLcr;
              this.hideModal();
              this.loading = false;
            }
          } else {
            this.loading = false;
          }
        }
      }
    }
  },
  components: {
    // Card: () => import('@/views/component/card.vue'),
    EditableInput: () => import('@/views/component/EditableInput.vue'),
    lcr: () => import('@/views/component/reglement/lcr.vue'),
    badge: () => import('@/views/component/badge.vue'),
    // SelectSimpleWithSearch,
    PieceJointe: () => import('@/views/component/Facture/PieceJointe.vue')
  },
  mounted() {
    // this.getClientsReglement({ type_partenaire: 'Client' });
  }
};
</script>

<style lang="scss">
.tabs-add-reglement-fac {
  width: 100%;

  .tab-add-reglement-fac {
    width: 50%;
    // margin: auto !important;
    // &:hover {
    // height: 35px;
    // }
  }

  .v-slide-group__content {
    justify-content: space-evenly;
    display: flex;
  }
}

.date-paiement-fac {
  .v-input__prepend-inner {
    margin-top: 14px !important;
  }
}
</style>
